import { Box, Skeleton, useTheme } from '@mui/material';

export default function LocationsLoader() {
  const theme = useTheme();

  return (
    <Box p={3}>
      {/* Page Title */}
      <Skeleton variant='text' width={240} height={40} sx={{ mb: 2 }} />

      {/* Location Usage Banner */}
      <Box
        bgcolor={theme.palette.background.paper}
        borderRadius='10px'
        p={2}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        mb={3}
      >
        <Skeleton variant='text' width={180} height={28} />
        <Skeleton variant='rectangular' width={100} height={32} sx={{ borderRadius: 1 }} />
      </Box>

      {/* Section Title */}
      <Skeleton variant='text' width={220} height={30} sx={{ mb: 2 }} />

      {/* Locations List */}
      {[1, 2, 3].map((idx) => (
        <Box
          key={`location-skeleton-${idx}`}
          bgcolor={theme.palette.background.paper}
          border='1px solid #ECECEC'
          borderRadius='10px'
          p={3}
          mb={2}
        >
          {/* Location Header */}
          <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
            <Skeleton variant='text' width={180} height={24} />
            <Skeleton variant='circular' width={24} height={24} />
          </Box>

          {/* Contact Person */}
          <Skeleton variant='text' width={140} height={20} sx={{ mb: 1 }} />

          {/* Contact Info Row */}
          <Box display='flex' gap={2} flexWrap='wrap' mb={2}>
            <Skeleton variant='rectangular' width={180} height={24} sx={{ borderRadius: 1 }} />
            <Skeleton variant='rectangular' width={120} height={24} sx={{ borderRadius: 1 }} />
            <Skeleton variant='rectangular' width={160} height={24} sx={{ borderRadius: 1 }} />
          </Box>

          {/* Dropdown */}
          <Skeleton variant='rectangular' width={200} height={36} sx={{ borderRadius: 1 }} />
        </Box>
      ))}
    </Box>
  );
}
